
const LOCALSTORAGE_STATE_KEY_NAME = 'mu_st';
const LOCALSTORAGE_ANALYTICS_NAME = 'mu_an';

class LocalStorageService {
    constructor() {
        if (!LocalStorageService.instance) {
            LocalStorageService.instance = this;

            if (typeof localStorage !== 'undefined') {
                this.storeState = {
                    data: JSON.parse(localStorage.getItem(LOCALSTORAGE_STATE_KEY_NAME) || '{}'),

                }
            }
        }

        return LocalStorageService.instance;
    }

    setInitialState(stateObj) {
        if (!this.storeState || !this.storeState.data || !stateObj) return;

        this.storeState.data = { ...stateObj };
        if (this.storeState.data.admin) delete this.storeState.data.admin;

        localStorage.setItem(LOCALSTORAGE_STATE_KEY_NAME, JSON.stringify(this.storeState.data));
    }

    getState(reducerName) {
        if (!this.storeState || !this.storeState.data) return {};

        if (!reducerName) return this.storeState.data;

        return this.storeState.data[reducerName] || {};
    }

    updateState(reducerName, key, value) {
        if (!reducerName || !this.storeState || !this.storeState.data) return;

        const newState = {
            ...this.storeState.data,
            [reducerName]: {
                ...this.storeState.data[reducerName],
                [key]: value
            }
        }

        this.setInitialState(newState);
    }

    incVisitCount(visitType) {
        if (!visitType) return;
        let viewAnalytics = JSON.parse(localStorage.getItem(LOCALSTORAGE_ANALYTICS_NAME) || '{}');

        if (viewAnalytics) {
            viewAnalytics[visitType] ? viewAnalytics[visitType]++ : viewAnalytics[visitType] = 1;
        }

        localStorage.setItem(LOCALSTORAGE_ANALYTICS_NAME, JSON.stringify(viewAnalytics || {}))
    }

    getVisitCount(visitType) {
        const viewAnalytics = JSON.parse(localStorage.getItem(LOCALSTORAGE_ANALYTICS_NAME) || '{}');

        if (visitType) return viewAnalytics[visitType];
        return viewAnalytics;
    }

}

const instance = new LocalStorageService();
Object.freeze(instance);

export default instance;



// WEBPACK FOOTER //
// ./src/Services/LocalStorageService.js